export const normalizeCouponForMachineLogin = (coupon: any) => {
  const discountType = String(coupon.discount_type ?? "percentage").toLowerCase();

  let normalizedType = "P";
  if (discountType === "absolute") {
    normalizedType = "F";
  } else if (discountType === "percentage") {
    normalizedType = "P";
  }

  const activeValue = coupon.active;
  const normalizedStatus = Number(activeValue ?? true);

  // Determine date_start and date_end based on coupon type
  let date_start = "1970-01-01";
  let date_end = "";

  if (coupon.user_coupon_id && coupon.user_coupon) {
    date_start = coupon.user_coupon.date_start || "1970-01-01";
    date_end = coupon.user_coupon.date_end || coupon.expiry_date || "";
  } else if (coupon.member_group_coupon_id && coupon.member_group_coupon) {
    date_start = coupon.member_group_coupon.date_start || "1970-01-01";
    date_end = coupon.member_group_coupon.date_end || coupon.expiry_date || "";
  } else {
    // Default scenario
    date_start = "1970-01-01";
    date_end = coupon.expiry_date ?? "";
  }

  return {
    coupon_id: coupon.id ?? null,
    name: coupon.name ?? "",
    code: coupon.code ?? "",
    type: normalizedType,
    discount: Number(coupon.discount_amount ?? 0),
    status: normalizedStatus,
    date_start: date_start,
    date_end: date_end,
    total_amount: Number(coupon.discount_amount ?? 0),
    spend_points: Number(coupon.minimum_spending ?? 0),
    tags: Array.isArray(coupon.tags) ? coupon.tags : [],
    customer_group_ids: Array.isArray(coupon.customer_group_ids) ? coupon.customer_group_ids : [],
    customer_ids: Array.isArray(coupon.customer_ids) ? coupon.customer_ids : [],
    machine_ids: Array.isArray(coupon.machine_ids) ? coupon.machine_ids : [],
    sku_ids: Array.isArray(coupon.target_skus) ? coupon.target_skus : [],
    collection_ids: Array.isArray(coupon.target_collections) ? coupon.target_collections : [],
    cart_sku_ids: Array.isArray(coupon.criterial_cart_skus) ? coupon.criterial_cart_skus : [],
    cart_collection_ids: Array.isArray(coupon.criterial_cart_collections) ? coupon.criterial_cart_collections : [],
    product_ids: Array.isArray(coupon.target_skus) ? coupon.target_skus : [],
  };
};

export const normalizeMachineCouponList = (coupons: any[] | null | undefined) => {
  if (!Array.isArray(coupons)) {
    return [];
  }

  return coupons.map(normalizeCouponForMachineLogin);
};

export const normalizeMachineRewardPoints = (value: any): number => {
  const parsedRewardPoints = Number(value?.result ?? value ?? 0);
  return Number.isFinite(parsedRewardPoints) && parsedRewardPoints > 0 ? parsedRewardPoints : 0;
};
